import React from "react";
import "./Header.css";

export default function Header() {
  return <h1 className="header">All weather is beautiful.</h1>;
}
